import apiClient from './axiosInstanceStock';

// Adding the owner-related function
export const updateProccesingPlantStatus = async (data) => {
  return await apiClient.post('/updateProccesingPlantStatus', data);
};